import React from 'react';
import CodeEditor from './CodeEditor';

const App = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Simple Code Editor</h1>
      <CodeEditor />
    </div>
  );
};


export default App;
